import { Injectable } from "@angular/core";
import { apiconstants } from "../constants/api.constant";
import { Observable, map } from "rxjs";
import { IResponse } from "../models/response";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class AcquisitionService {
  constructor(private _http: HttpClient) {}

  getAllAcquisitionsByProjectId(projectId: string): Observable<any> {
    return this._http
      .get(apiconstants.API_GET_ALL_ACQUISITIONS + "/" + projectId)
      .pipe(
        map((response: IResponse) => {
          return response.data;
        })
      );
  }

  getAllAcquisitionsByFolderId(folderId: string): Observable<any> {
    return this._http
      .get(apiconstants.API_GET_ALL_ACQUISITIONS_BY_FOLDER_ID + "/" + folderId)
      .pipe(
        map((response: IResponse) => {
          return response.data;
        })
      );
  }

  uploadAcquisition(params) {
    return this._http.post(apiconstants.API_ACQUISITION, params).pipe(
      map((response: IResponse) => {
        return response;
      })
    );
  }

  getAllAcquisitionCodes(projectType?: number) {
    let params = {};
    projectType ? (params = { projectType }) : 0;
    
    return this._http
      .get(apiconstants.API_GET_ALL_ACQUISITION_CODES, { params })
      .pipe(
        map((response: IResponse) => {
          return response.data;
        })
      );
  }

  deleteAcquisition(acquisitionId) {
    return this._http
      .delete(apiconstants.API_ACQUISITION + "/" + acquisitionId)
      .pipe(
        map((response: IResponse) => {
          return response.data;
        })
      );
  }
}
